<template>
  <section v-if="$route.params" class="container-wrapper thank-you-page">
    <h1 class="thank-you-page__title">
      {{ $route.params.title }}
    </h1>
    <div class="thank-you-page__text p" v-html="$route.params.description" />
    <div
      v-show="$route.params.buttonLabel"
      class="thank-you-page__button-wrapper"
    >
      <BaseButton
        type="primary"
        class="thank-you-page__button"
        @click="navigateHome"
      >
        {{ $route.params.buttonLabel }}
        <IconArrow class="icon-left" />
      </BaseButton>
    </div>
  </section>
</template>

<script>
  // Step 6
  import { mapActions } from 'vuex'
  import IconArrow from '@/assets/img/icons/arrow-long-right.svg?inline'

  export default {
    name: 'ThankYouPage',

    components: {
      IconArrow
    },

    beforeMount () {
      if (this._.isEmpty(this.$route.params)) {
        // this.$router.go(-1)
        this.$router.push('/service')
      }
    },

    methods: {
      ...mapActions(['fetchThankYouPageData']),
      navigateHome () {
        this.$route.params.url ? this.$router.push(this.$route.params.url) : this.$router.go(-1)
      }
    }
  }
</script>

<style lang="scss">
.iframe{
  height: auto!important;
  .thank-you-page{
    padding-top: 124px;
  }
}
  .thank-you-page {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .icon-left {
      position: relative;
      top: -1px;
      height: 14px;
      margin-left: 8px;
      color: $c-white;
    }

    .button {
      width: unset !important;
    }

    @media (-ms-high-contrast: none), (-ms-high-contrast: active) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: calc(100vh - 80px);
      min-height: 300px;
    }

    &__title {
      font-family: 'NobelWGL-Book', sans-serif;
      letter-spacing: 2px;
      max-width: 100%;
      margin-bottom: 25px;
      color: #1a1a1f;
    }

    &__text {
      font-family: 'NobelWGL-Book', sans-serif;
      letter-spacing: 2px;
      max-width: 100%;
      color: #1a1a1f;
      text-align: center;
    }

    &__button {
      &-wrapper {
        display: flex;
        justify-content: center;
        max-width: 100%;
      }

      margin-top: 50px;

      @include mobile {
        margin-top: 25px;
      }
    }
  }
</style>
